import { Clock } from "lucide-react";

interface EndOfListProps {
  message: string;
  description: string;
}

/**
 * "You've seen it all" — the marker at the end of a fully loaded list.
 *
 * Two exports rather than one with a `variant`: the table drops it into a
 * `<td>` that already spans the row, while the grid needs it boxed like a card
 * so it sits in the grid track as one. Only the content is shared, which is the
 * part that was drifting between the three copies.
 */
export function EndOfListMessage({ message, description }: EndOfListProps) {
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <div className="bg-base-content/10 rounded-full p-2">
        <Clock size={24} className="text-base-content/50" />
      </div>
      <div className="space-y-0.5">
        <p className="text-base-content/70 text-sm font-medium">{message}</p>
        <p className="text-base-content/50 text-xs">{description}</p>
      </div>
    </div>
  );
}

export function EndOfListCard(props: EndOfListProps) {
  return (
    <div className="rounded-box border-base-content/20 bg-base-100 flex h-full w-full flex-col items-center justify-center border p-4 text-center">
      <EndOfListMessage {...props} />
    </div>
  );
}
